var _style, _path, _path2, _polygon, _rect, _rect2, _rect3, _rect4, _path3, _path4, _polygon2, _rect5, _rect6, _circle, _polygon3, _rect7, _rect8, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoublebonex2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st398{fill:#FFFFFF;stroke:#000000;stroke-width:3.52;stroke-miterlimit:10;}\n\t.st397{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st396{fill:#FFFFFF;stroke:#000000;stroke-width:1.17;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st398",
    d: "M57.6,361.2c0.8-15,2.1-30.5,3.6-46.5c4.8-49.9,11.8-91.1,17.3-119.1c4,0.2,7.9,0.5,11.8,0.6 c3.6,0.1,7.3,0.2,10.9,0.2c28.5,0.4,56.9-1.8,85.3-1.4c3.6,0,7.3,0.1,10.9,0.2c4.7,0.1,9.3,0.4,14,0.7 c-0.2,52.6-0.4,109.8-0.5,165.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st398",
    d: "M212.1,361.2c-0.2-55.3-0.4-112.5-0.6-165.1c4.9-0.3,9.8-0.6,14.8-0.7c3.6-0.1,7.3-0.2,10.9-0.2 c29.2-0.2,58.5,2,87.7,1.4c3.6,0,7.3-0.1,10.9-0.4c2.9-0.1,5.7-0.4,8.7-0.5c5.5,28,12.4,69,17.4,119.1c1.5,16.1,2.7,31.6,3.6,46.5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st397",
    points: "345.7,194.5 77.5,194.5 82.1,162.4 341.1,162.4 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 171.2,
    y: 175.2,
    transform: "matrix(2.111690e-02 -0.9998 0.9998 2.111690e-02 7.8217 369.235)",
    className: "st396",
    width: 42.6,
    height: 10.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 175.2,
    transform: "matrix(2.111690e-02 -0.9998 0.9998 2.111690e-02 -86.3768 273.023)",
    className: "st396",
    width: 42.6,
    height: 10.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 159.3,
    transform: "matrix(0.9998 -2.111691e-02 2.111691e-02 0.9998 -3.7616 4.9274)",
    className: "st396",
    width: 10.9,
    height: 42.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 159.3,
    transform: "matrix(0.9998 -2.111691e-02 2.111691e-02 0.9998 -3.7394 7.0086)",
    className: "st396",
    width: 10.9,
    height: 42.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st396",
    d: "M141.6,199.1c-2.3,25.2-4.6,41.2-6.9,66.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st396",
    d: "M286,199.1c2.4,25.2,4.6,38.9,6.9,64.2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st396",
    points: "180.9,273.1 93.8,273.1 93.6,266.9 180.7,266.9 "
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 93.6,
    y: 270.1,
    className: "st396",
    width: 87.1,
    height: 2.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 133.1,
    y: 266.9,
    className: "st396",
    width: 3.5,
    height: 15.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134.9,
    cy: 280.4,
    r: 5.3
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st396",
    points: "337.1,272.1 250.1,272.1 249.8,266 336.9,266 "
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 249.8,
    y: 269.2,
    className: "st396",
    width: 87.1,
    height: 2.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 289.5,
    y: 266,
    className: "st396",
    width: 3.5,
    height: 15.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.1,
    cy: 279.4,
    r: 5.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoublebonex2);
export default __webpack_public_path__ + "static/media/DOUBLE BONE X 2.003202c3ba7530416a815cf5052b2ba1.svg";
export { ForwardRef as ReactComponent };